import HomeInfo from '../api/HomeInfo';

function bearerToken() {
	if (localStorage.reconToken) {
		return localStorage.reconToken;
	}
	try {
		const auth = JSON.parse(localStorage.getItem('authentication') || '{}');
		return auth.access_token || null;
	} catch (e) {
		return null;
	}
}

/**
 * Development + local API only (`npm run start-local`).
 * Sticky-switches Puma via POST /api/dev/dealer_connection for the rooftop.
 * Always POSTs (idempotent): sticky state is process-wide on the API and can
 * change under us (Playwright, another tab, API restart) — a client-side skip
 * cache would go stale. No-ops in production builds / when the endpoint is missing.
 */
export function switchDevDealerConnectionIfNeeded(subdomain) {
	if (!HomeInfo.isLocalDevApi() || !subdomain) {
		return Promise.resolve(null);
	}

	const token = bearerToken();
	const base = HomeInfo.baseUrl();
	if (!token || !base) {
		return Promise.resolve(null);
	}

	return fetch(`${base}dev/dealer_connection`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ subdomain }),
	})
		.then((response) => {
			if (!response.ok) {
				// Older APIs / non-dev: do not block dealership select.
				console.warn(`[dev] dealer_connection ${response.status} for ${subdomain}`);
				return null;
			}
			return response.json();
		})
		.catch((err) => {
			console.warn('[dev] dealer_connection error', err);
			return null;
		});
}
